module.exports = __webpack_public_path__ + "static/media/Web_zh.98fa3b19.png";